import { COMMERCE_PAYMENT_TYPE_ID } from '../constants/ObjectTypeIds';
const ALWAYS_EDITABLE_PROPERTIES = new Set(['hs_all_assigned_business_unit_ids', 'hubspot_owner_id']);
export const isReadOnlyPaymentProperty = ({
  objectTypeId,
  property,
  paymentsEnabled
}) => {
  if (objectTypeId !== COMMERCE_PAYMENT_TYPE_ID || !property.hubspotDefined) {
    // if objectTypeId is not a payment or it's a custom property, it should be editable
    return false;
  }

  // Controlling property (hs_hubspot_payments_enabled) - Whether Hubspot payments is enabled for this payment
  // https://tools.hubteam.com/lighthouse/objects/COMMERCE_PAYMENT/properties/hs_hubspot_payments_enabled/details/0
  if (paymentsEnabled === 'false' || ALWAYS_EDITABLE_PROPERTIES.has(property.name)) {
    // HubSpot Payments does not manage this object, so properties are editable
    return false;
  }

  // By default, hubspot-defined payment properties are read only
  return true;
};